import { render, staticRenderFns } from "./ContentManagement.vue?vue&type=template&id=a6fbb21c&scoped=true"
import script from "./ContentManagement.vue?vue&type=script&lang=js"
export * from "./ContentManagement.vue?vue&type=script&lang=js"
import style0 from "./ContentManagement.vue?vue&type=style&index=0&id=a6fbb21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fbb21c",
  null
  
)

export default component.exports